import { Box, Table, Tbody, Td, Th, Thead, Tr } from '@ff-it/ui';
import { openPlanModal } from '../openPlanModal';
import { DialogForm } from 'components';
import { PlanRow } from 'modules/campaign/row';
import { ReactElement, ReactNode } from 'react';
import { toast } from 'react-toastify';

import type { PlanMutations } from '../state/mutate';
import { ViewSupplier } from '../components/ViewSupplier';
import { PlanRowIcons } from '../components/PlanRowIcons';

type UpdateFn = PlanMutations['update'];

type BulkUpdateDialogConfig<TFormValues> = {
  dialogHeader: string;
  renderFields: () => ReactElement;
  renderCurrentValue: (row: PlanRow) => ReactNode;
  buildPatch: (row: PlanRow, values: TFormValues) => Record<string, unknown>;
};

export function openBulkUpdateDialog<TFormValues>(
  rows: PlanRow[],
  update: UpdateFn,
  config: BulkUpdateDialogConfig<TFormValues>,
): void {
  openPlanModal(
    (props) => (
      <DialogForm
        {...props}
        title={config.dialogHeader}
        submitHandler={async (values: TFormValues) =>
          update({
            rows: {
              upsert: rows.map((r) => ({
                id: r.id,
                ...config.buildPatch(r, values),
              })),
            },
          }).then((r) => {
            r.assertOk();
            toast.success(`Rows updated!`);
          })
        }
      >
        {config.renderFields()}
        <Box style={{ maxHeight: '40vh', overflowY: 'auto' }}>
          <Table size="sm">
            <Thead>
              <Tr>
                <Th>Row</Th>
                <Th>Current value</Th>
              </Tr>
            </Thead>
            <Tbody>
              {rows.map((row) => (
                <Tr key={row.id}>
                  <Td className="py-0">
                    <Box flexDirection="row" display="flex" alignItems="center">
                      <PlanRowIcons row={row} />
                      <ViewSupplier row={row} />
                    </Box>
                  </Td>
                  <Td>{config.renderCurrentValue(row)}</Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </Box>
      </DialogForm>
    ),
    { testId: 'bulk-update' },
  );
}
